document.addEventListener('DOMContentLoaded', function() {
    var targetNode = document.querySelector('.product-gallery__fullscreen');

    if (!targetNode) {
        console.log('Target node for observer (.product-gallery__fullscreen) not found.');
        return;
    }

    var config = { attributes: true, attributeFilter: ['class'] };

    var observer = new MutationObserver(function(mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                console.log('Class attribute changed on target node.');
                if (targetNode.classList.contains('show') && targetNode.classList.contains('visible')) {
                    console.log('Target node has both "show" and "visible" classes.');
                    var badgeWrap = document.querySelector('.badge_wrap2024');
                    if (badgeWrap && !badgeWrap.classList.contains('d-none')) {
                        badgeWrap.classList.add('d-none');
                        console.log('"d-none" class added to badge_wrap2024.');
                    }
                } else {
                    console.log('Target node does not have both "show" and "visible" classes.');
                    var badgeWrap = document.querySelector('.badge_wrap2024');
                    if (badgeWrap && badgeWrap.classList.contains('d-none')) {
                        badgeWrap.classList.remove('d-none');
                        console.log('"d-none" class removed from badge_wrap2024.');
                    }
                }
            }
        }
    });

    observer.observe(targetNode, config);
});